module.exports = __webpack_public_path__ + "static/media/silver.0833bf3e.png";